import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {AccountService} from '../../../services/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {CustomerDetail} from '../../../domain/customer/customer-detail';
import {LocalStorageService} from 'angular-2-local-storage';
import {Account} from '../../../domain/accounts/account';
import * as moment from 'moment';
import {MediaAccess} from '../../../domain/accounts/media-access';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CustomerDetailService} from '../../../services/customer-detail.service';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {AccountConfiguration} from '../../../domain/configurations';
import {takeUntil} from 'rxjs/operators';
import {ReplaySubject} from 'rxjs';

@Component({
  selector: 'app-cancellation',
  templateUrl: './cancellation.component.html',
  styleUrls: ['./cancellation.component.scss']
})
export class CancellationComponent extends CommonComponent implements OnInit, OnDestroy {
  canceled: boolean;
  dateRequested: string = moment().format('yyyy-MM-DD');
  customerDetail: CustomerDetail;
  activeAccount: Account;
  mediaAccessActive: MediaAccess;
  configurations: AccountConfiguration;
  enableAccountCancellation: boolean;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private localStorageService: LocalStorageService,
    private accountsService: AccountService,
    private customerDetailService: CustomerDetailService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private configurationsService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configurations = this.configurationsService.account;
  }

  ngOnInit(): void {
    if (this.configurations.enableAccountCancellation === false) {
      this.router.navigateByUrl('account/balance');
    }
    this.getCustomerDetail();
  }

  getCustomerDetail() {
    this.loadingModalOn();
    this.customerDetailService.customerDetail$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.customerDetail = response;
        for (const account of this.customerDetail.accounts) {
          if (account.status === this.accountStatus.ACTIVE) {
            this.activeAccount = account;
            for (const mediaAccess of this.activeAccount.mediaAccess) {
              if (mediaAccess.status === this.eMediaAccessStatus.ACTIVE) {
                if (mediaAccess.type === this.eMediaAccessType.CARD) {
                  this.mediaAccessActive = mediaAccess;
                } else {
                  this.mediaAccessActive = null;
                }
              } else {
                this.mediaAccessActive = null;
              }
            }
          } else {
            this.activeAccount = null;
          }
        }
        this.loadingModalOff();
      }, error => {
        switch (error.status) {
          case 409:
            break;
          default:
            this.msgError(error, this.translate.instant('accounts.balance.notifications.error_data_message'));
            break;
        }
        this.loadingModalOff();
      }
    );
  }

  cancelAccount() {
    this.accountsService.cancelAccount().subscribe(
      (response: any) => {
        this.canceled = true;
        this.dateRequested = moment().format('yyyy-MM-DD');
        this.loadingModalOff();
      }, error => {
        switch (error.status) {
          case 409:
            break;
          default:
            this.msgError(error, this.translate.instant('accounts.balance.notifications.error_cancel_message'));
            break;
        }
        this.loadingModalOff();
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}
